import React from 'react';
import { motion } from 'framer-motion';

const StartMenu = ({ onStartGame, onShowInstructions }) => {
  return (
    <div className="h-full flex flex-col items-center justify-center text-center">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <h1 className="text-6xl md:text-8xl font-mono font-bold bg-gradient-to-r from-blue-300 via-purple-300 to-pink-300 bg-clip-text text-transparent tracking-wider text-glow">
          Dragon Collector
        </h1>
        <p className="text-lg md:text-xl text-gray-300 mt-4 font-sans">
          An epic journey of collection and breeding awaits.
        </p>
      </motion.div>

      <motion.div
        className="mt-12 flex flex-col sm:flex-row gap-4"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4, ease: 'easeOut' }}
      >
        <button
          onClick={onStartGame}
          className="btn btn-primary px-12 py-4 text-xl"
        >
          Start Game
        </button>
        <button
          onClick={onShowInstructions}
          className="btn btn-secondary px-12 py-4 text-xl"
        >
          Instructions
        </button>
      </motion.div>
    </div>
  );
};

export default StartMenu;
